// removed by extract-text-webpack-plugin
module.exports = {"component":"_13ApuZa3BKCSIuA2LcgLJ5","tactTitle":"_3tXZsGWFo8yLTlmZ2IirMd","tactLink":"_3GrT4YxYJtYqNsSbpwi-vy","tactTxt":"_1ufEBqeOK2xRY_Sog-qg81","content":"IOLXv0-7hctLVsOwF9uaM"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/StandardDisclaimer/StandardDisclaimer.scss
 ** module id = 1098
 ** module chunks = 0
 **/